import { useMutation } from 'react-query';

import { saveProjectAs } from 'shared/api/projects/http';

const useMutateSaveProjectAs = (options = undefined) =>
  useMutation(({ id, saveAs }) => saveProjectAs(id, saveAs), options);

export default useMutateSaveProjectAs;
